// src/hooks/useRouteAuthCheck.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useRouteAuthCheck = () => {
  const location = useLocation();

  useEffect(() => {
    const checkAndReLogin = async () => {
      try {
        // Get values from localStorage
        const authUserStr = localStorage.getItem('authUser');
        const dataSaved = localStorage.getItem('datasaved');

        // Case 1: No authUser - do nothing
        if (!authUserStr) {
          console.log('[RouteAuthCheck] No authUser found, skipping re-login');
          return;
        }

        // Case 2: Both authUser and datasaved exist - do nothing
        if (authUserStr && dataSaved) {
          console.log('[RouteAuthCheck] Both authUser and datasaved exist, skipping re-login');
          return;
        }

        // Case 3: authUser exists but datasaved doesn't - call login
        if (authUserStr && !dataSaved) {
          console.log('[RouteAuthCheck] authUser exists but datasaved missing, calling login API...');
          
          const authUser = JSON.parse(authUserStr);
          
          // Check if required fields exist (EmployeeID and Email)
          if (!authUser.EmployeeID || !authUser.Email) {
            console.warn('[RouteAuthCheck] authUser missing required fields (EmployeeID or Email)');
            return;
          }

          // Prepare the login payload with EmployeeID and Email
          const loginPayload = {
            EmployeeID: authUser.EmployeeID,  // Capital E and I
            Email: authUser.Email,             // Capital E
          };

          console.log('[RouteAuthCheck] Sending re-login request with:', loginPayload);

          // Call the login API
          const response = await fetch(process.env.REACT_APP_ADMIN + "/login", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(loginPayload),
          });

          const data = await response.json();
          console.log('[RouteAuthCheck] Re-login response:', data);

          // If login successful, update authUser and set datasaved
          if (data.success && data.data && data.data.Email) {
            localStorage.setItem('authUser', JSON.stringify(data.data));
            localStorage.setItem('datasaved', 'true');
            console.log('[RouteAuthCheck] Re-login successful, datasaved set to true');
          } else {
            console.error('[RouteAuthCheck] Re-login failed:', data.mssg || 'Unknown error');
            // Optionally clear authUser if login fails
            // localStorage.removeItem('authUser');
          }
        }
      } catch (error) {
        console.error('[RouteAuthCheck] Error in route auth check:', error);
      }
    };

    checkAndReLogin();
  }, [location.pathname]); // Run on every route change
};